"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const am4core = __importStar(require("@amcharts/amcharts4/core"));
const am4charts = __importStar(require("@amcharts/amcharts4/charts"));
const animated_1 = __importDefault(require("@amcharts/amcharts4/themes/animated")); // eslint-disable-line
const classnames_1 = __importDefault(require("classnames"));
const mui_1 = require("tss-react/mui");
const material_1 = require("@mui/material");
const selectors_1 = require("data/transactionList/selectors");
const transactionsSelectors = __importStar(require("data/transactions/selectors"));
const constants_1 = require("../constants");
const styles_1 = require("./styles");
const useStyle = (0, mui_1.makeStyles)()(styles_1.styles);
const AMGraph = ({ dateRange, accountIds, oneColor, transactionsPageOptimize, setSelectedId }) => {
    const isLoading = (0, react_redux_1.useSelector)((state) => transactionsSelectors.getLoadPending(state));
    const chartData = (0, react_redux_1.useSelector)((state) => !isLoading ? (0, selectors_1.getAMChartData)(state, { dateRange: 180 }) : null);
    const chartRef = (0, react_1.useRef)(null);
    const dateAxisRef = (0, react_1.useRef)(null);
    const valueAxisRef = (0, react_1.useRef)(null);
    const chartDataRef = (0, react_1.useRef)(null);
    const dateRangeRef = (0, react_1.useRef)(dateRange);
    const accountIdsRef = (0, react_1.useRef)(accountIds);
    const { classes, theme } = useStyle();
    const getStartIndex = () => {
        switch (constants_1.TYPE_VALUES[dateRange]) {
            case 7:
                return 8;
            case 14:
                return 6;
            case 30:
                return 2;
            case 45:
                return 1;
            case 60:
                return 0;
            case 90:
                return 0;
            default:
                return 3;
        }
    };
    const zoomGraph = (instantly = false) => {
        var _a, _b, _c;
        if (!chartData)
            return;
        const startIndex = getStartIndex();
        const startDate = (_b = (_a = chartData === null || chartData === void 0 ? void 0 : chartData.get(accountIds.first())) === null || _a === void 0 ? void 0 : _a.chartData[startIndex]) === null || _b === void 0 ? void 0 : _b.date;
        const endDate = new Date();
        (_c = dateAxisRef.current) === null || _c === void 0 ? void 0 : _c.zoomToDates(new Date(startDate), 
        // @ts-expect-error: Argument of type 'number' is not assignable to parameter of type 'Date'.
        endDate.setDate(endDate.getDate() + constants_1.TYPE_VALUES[dateRange] - 1), false, instantly);
    };
    const hideBullet = (bullet) => {
        // eslint-disable-next-line no-param-reassign
        bullet.visible = !(bullet.pixelX < 0 ||
            bullet.pixelX > chartRef.current.plotContainer.measuredWidth ||
            bullet.pixelY < 0 ||
            bullet.pixelY > chartRef.current.plotContainer.measuredHeight);
    };
    const setSeriesData = (data, series) => {
        if (data) {
            // eslint-disable-next-line no-param-reassign
            series.data = data.map((day) => ({
                balance: day.balance,
                chartDate: day.date,
                disabled: day.disabled,
                noIncome: day.noIncome,
                noRefund: day.noRefund,
                transactions: day.txns,
                firstTxnId: day === null || day === void 0 ? void 0 : day.firstTxnId,
            }));
        }
    };
    const greyLevel3 = theme.palette.grey.level3;
    const buildTooltipSeriesInfo = (series) => (`<div style="color: ${theme.palette.text.secondary};border-radius: ${theme.shape.borderRadius * 2}px;padding: ${theme.shape.padding[2]}px;text-align: left;" >
    <div style="width: 172px;display: flex;flex-direction: row;align-items: center;color: ${theme.palette.text.secondary};" >
      <div style="background: ${series.stroke};width: 12px;height: 12px;border-radius: 50%;margin-right: 3px;font-weight: 400;" ></div>
      <span style="flex-grow: 1;display: flex;justify-content: space-between;font-size: 14px;min-width: 140px" >
          <span style="flex: 2;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;text-transform: capitalize;font-weight: 400;" id="tooltip_category" >${series.name}</span>
          <span style="flex: 1;text-align: right;font-weight: 400;" id="tooltip_amount" >\${${series.dataFields.valueY}.formatNumber('#,###.00')}</span>
        </span>
    </div>
    <span style="flex: 1;text-align: right; flex-direction: column" id="transactions" >{transactions}</span>
    <div style="width: 100%;height: 2px;border-bottom-width: 1px;border-bottom-style: solid;border-bottom-color: ${greyLevel3};margin: 5px 0px;"></div>
    <div style="display: flex; justify-content: space-between">
      <span style="color: ${theme.palette.text.secondary};font-size: 12px;height: 12px; font-weight: 400;" id="tooltip_date" >{${series.dataFields.dateX}.formatDate('MMM d, yyyy')}</span>
      <span style="font-size: 12px; font-weight: 400;">Projected</span>
    </div>
  </div>`);
    const onBulletHit = (e) => {
        const { dataItem } = e.target;
        const formatter = new am4core.DateFormatter();
        let myDate = formatter.format(dataItem === null || dataItem === void 0 ? void 0 : dataItem.dateX, 'i');
        myDate = myDate.replace('Z', '');
        setSelectedId([dataItem === null || dataItem === void 0 ? void 0 : dataItem.customValue, myDate]);
    };
    const createIndividualSeries = (data, accountId, chart) => {
        var _a, _b, _c;
        if (!data)
            return;
        const color = !oneColor
            ? am4core.color(theme.palette.data.sequence1[data.index % 9])
            : am4core.color(theme.palette.primary.main);
        const lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.id = accountId;
        setSeriesData(data === null || data === void 0 ? void 0 : data.chartData, lineSeries);
        lineSeries.dataFields.dateX = 'chartDate';
        lineSeries.dataFields.valueY = 'balance';
        lineSeries.dataFields.customValue = 'firstTxnId';
        // lineSeries.tooltipHTML = "{html}";
        lineSeries.tensionX = 1;
        lineSeries.strokeWidth = 1.5;
        lineSeries.stroke = am4core.color(theme.palette.primary.main);
        lineSeries.strokeDasharray = '4, 4';
        lineSeries.name = (data === null || data === void 0 ? void 0 : data.name) || 'Error';
        lineSeries.stroke = color;
        lineSeries.hidden = !accountIds.includes(accountId);
        lineSeries.tooltip = new am4core.Tooltip();
        lineSeries.tooltip.label.padding(0, 0, 0, 0);
        lineSeries.tooltip.background.strokeWidth = 0;
        lineSeries.tooltip.background.cornerRadius = theme.shape.borderRadius * 2;
        // lineSeries.tooltip.zIndex = Infinity;
        lineSeries.tooltip.interactionsEnabled = true;
        lineSeries.tooltip.showInViewport = true;
        const shadow = lineSeries.tooltip.background.filters.getIndex(0);
        shadow.dx = 0;
        shadow.dy = 2;
        shadow.blur = 4;
        shadow.spread = 0;
        shadow.opacity = 0.8;
        shadow.color = am4core.color(theme.applyOpacityToHex(theme.palette.grey.level3, 0.9));
        lineSeries.tooltipHTML = buildTooltipSeriesInfo(lineSeries);
        const circleBullet = lineSeries.bullets.push(new am4charts.CircleBullet());
        circleBullet.circle.radius = 10;
        circleBullet.circle.fill = am4core.color(theme.palette.number.positive);
        circleBullet.circle.stroke = am4core.color(theme.palette.common.white);
        circleBullet.circle.strokeWidth = 1;
        circleBullet.align = 'center';
        circleBullet.valign = 'middle';
        circleBullet.circle.horizontalCenter = 'middle';
        circleBullet.propertyFields.disabled = 'noIncome';
        circleBullet.cursorOverStyle = am4core.MouseCursorStyle.pointer;
        circleBullet.events.on('hit', onBulletHit);
        circleBullet.adapter.add('dy', (dy, target) => {
            hideBullet(target);
            return dy;
        });
        const blueCircleBullet = lineSeries.bullets.push(new am4charts.CircleBullet());
        blueCircleBullet.circle.radius = 6;
        blueCircleBullet.circle.fill = color;
        blueCircleBullet.circle.stroke = am4core.color(theme.palette.common.white);
        blueCircleBullet.circle.strokeWidth = 1;
        blueCircleBullet.align = 'center';
        blueCircleBullet.valign = 'middle';
        blueCircleBullet.circle.horizontalCenter = 'middle';
        blueCircleBullet.propertyFields.disabled = 'disabled';
        blueCircleBullet.cursorOverStyle = am4core.MouseCursorStyle.pointer;
        blueCircleBullet.events.on('hit', onBulletHit);
        blueCircleBullet.adapter.add('dy', (dy, target) => {
            hideBullet(target);
            return dy;
        });
        const refundCircleBullet = lineSeries.bullets.push(new am4charts.CircleBullet());
        refundCircleBullet.circle.radius = 6;
        refundCircleBullet.circle.fill = am4core.color(theme.palette.color4.opacity100);
        refundCircleBullet.circle.stroke = am4core.color(theme.palette.common.white);
        refundCircleBullet.circle.strokeWidth = 1;
        refundCircleBullet.align = 'center';
        refundCircleBullet.valign = 'middle';
        refundCircleBullet.circle.horizontalCenter = 'middle';
        refundCircleBullet.propertyFields.disabled = 'noRefund';
        refundCircleBullet.cursorOverStyle = am4core.MouseCursorStyle.pointer;
        refundCircleBullet.events.on('hit', onBulletHit);
        refundCircleBullet.adapter.add('dy', (dy, target) => {
            hideBullet(target);
            return dy;
        });
        const bullets = lineSeries.bullets.push(new am4charts.LabelBullet());
        bullets.label.text = '$';
        bullets.label.fontSize = 9;
        bullets.label.width = 8;
        bullets.label.height = 12;
        bullets.align = 'center';
        bullets.valign = 'middle';
        bullets.label.fill = am4core.color(theme.palette.white);
        bullets.dy = 1.2;
        bullets.dx = 1.3;
        bullets.propertyFields.disabled = 'noIncome';
        bullets.adapter.add('dy', (dy, target) => {
            hideBullet(target);
            return dy;
        });
        const blueBulletHoverState = blueCircleBullet.states.create('hover');
        blueBulletHoverState.properties.scale = 1.4;
        blueBulletHoverState.properties.stroke = color;
        const refundBulletHoverState = refundCircleBullet.states.create('hover');
        refundBulletHoverState.properties.scale = 1.4;
        refundBulletHoverState.properties.stroke = color;
        const circleBulletHoverState = circleBullet.states.create('hover');
        circleBulletHoverState.properties.scale = 1.4;
        circleBulletHoverState.properties.stroke = color;
        /* Configure line series tooltip */
        lineSeries.tooltip.getFillFromObject = false;
        lineSeries.tooltip.pointerOrientation = 'vertical';
        lineSeries.tooltip.background.cornerRadius = 4;
        lineSeries.tooltip.background.pointerLength = 10;
        lineSeries.tooltip.background.valign = 'middle';
        lineSeries.tooltip.background.marginTop = 0;
        lineSeries.tooltip.background.marginBottom = 50;
        lineSeries.tooltip.background.fill = am4core.color(theme.palette.white);
        lineSeries.tooltipY = 0;
        lineSeries.tooltip.background.pointerLength = 0;
        const rect = new am4core.Rectangle();
        rect.opacity = 0;
        rect.x = -100;
        rect.y = -100;
        rect.height = 200;
        rect.width = 200;
        rect.parent = lineSeries.tooltip;
        // rect.zIndex = Infinity;
        rect.cursorOverStyle = am4core.MouseCursorStyle.pointer;
        rect.events.on('hit', onBulletHit);
        const todayDate = new Date();
        const rangeSolid = (_a = dateAxisRef.current) === null || _a === void 0 ? void 0 : _a.createSeriesRange(lineSeries);
        if (rangeSolid) {
            rangeSolid.date = new Date((_b = lineSeries === null || lineSeries === void 0 ? void 0 : lineSeries.data[0]) === null || _b === void 0 ? void 0 : _b.date);
            rangeSolid.endDate = todayDate;
            rangeSolid.endValue -= 15000000;
            rangeSolid.contents.strokeDasharray = '0,0';
            rangeSolid.locations.date = 0;
            rangeSolid.locations.endDate = 1;
        }
        if ((_c = chartRef.current) === null || _c === void 0 ? void 0 : _c.cursor) {
            chartRef.current.cursor.snapToSeries = [...chartRef.current.series];
        }
    };
    const getIndex = () => {
        switch (constants_1.TYPE_VALUES[dateRange]) {
            case 7:
                return 0;
            case 14:
                return 1;
            case 30:
                return 2;
            case 45:
                return 3;
            case 60:
                return 4;
            case 90:
                return 5;
            default:
                return 6;
        }
    };
    const setActualMin = () => {
        let actualMin = 0;
        let actualMax = 0;
        const arrIndex = getIndex();
        accountIds.forEach((id) => {
            var _a, _b, _c, _d, _e;
            // @ts-expect-error: Argument of type 'number' is not assignable to parameter of type 'string'.
            const keyId = (_a = chartRef.current) === null || _a === void 0 ? void 0 : _a.map.getKey(id);
            if (keyId) {
                keyId.show();
            }
            else {
                createIndividualSeries(chartData === null || chartData === void 0 ? void 0 : chartData.get(id), id, chartRef.current);
            }
            if (actualMin > ((_b = chartData === null || chartData === void 0 ? void 0 : chartData.get(id)) === null || _b === void 0 ? void 0 : _b.minArr[arrIndex])) {
                actualMin = (_c = chartData === null || chartData === void 0 ? void 0 : chartData.get(id)) === null || _c === void 0 ? void 0 : _c.minArr[arrIndex];
            }
            if (actualMax < ((_d = chartData === null || chartData === void 0 ? void 0 : chartData.get(id)) === null || _d === void 0 ? void 0 : _d.maxArr[arrIndex])) {
                actualMax = (_e = chartData === null || chartData === void 0 ? void 0 : chartData.get(id)) === null || _e === void 0 ? void 0 : _e.maxArr[arrIndex];
            }
        });
        if (valueAxisRef.current) {
            valueAxisRef.current.min = actualMin;
            valueAxisRef.current.max = actualMax;
        }
    };
    const createSeriesFromData = (chart) => {
        var _a;
        if (transactionsPageOptimize) {
            // this is for specifically showing one series at a time. We do this on the transactions page instead of hiding individual series so that upon navigation,
            // transactions page chart isn't overwhelmed with too many series with too much data and takes less time to mount
            createIndividualSeries(chartData === null || chartData === void 0 ? void 0 : chartData.get(accountIds.first()), accountIds.first(), chart);
        }
        else {
            chartData.forEach((data, accountId) => {
                createIndividualSeries(data, accountId, chart);
            });
        }
        const todayRange = (_a = dateAxisRef.current) === null || _a === void 0 ? void 0 : _a.axisRanges.create();
        const todayDate = new Date().valueOf();
        if (todayRange) {
            todayRange.value = todayDate;
            todayRange.grid.stroke = am4core.color(theme.components.projectedBalances.todayBar);
            todayRange.grid.strokeOpacity = 1;
            todayRange.grid.strokeWidth = 2;
            todayRange.grid.dx = 4;
            // @ts-expect-error: Type 'boolean' is not assignable to type 'string'.
            todayRange.label.text = true;
            todayRange.label.text = 'Today';
            // @ts-expect-error: Type '500' is not assignable to type 'FontWeight'.
            todayRange.label.fontWeight = 500;
            todayRange.label.fill = am4core.color(theme.palette.black);
            todayRange.label.dy = -30;
            todayRange.label.dx = 0;
            todayRange.grid.above = false;
            todayRange.label.inside = true;
            todayRange.label.valign = 'top';
            todayRange.grid.horizontalCenter = 'left';
            todayRange.value -= 15000000;
            todayRange.locations.date = 0;
            todayRange.grid.location = 0;
        }
        setActualMin();
    };
    const generateGraph = () => {
        if (!chartData)
            return;
        chartDataRef.current = chartData;
        am4core.useTheme(animated_1.default);
        am4core.options.autoDispose = true;
        const container = am4core.create('chart-div-projected-balance', am4core.Container);
        container.width = am4core.percent(100);
        container.height = am4core.percent(93);
        container.y = 44;
        container.layout = 'vertical';
        const chart = container.createChild(am4charts.XYChart);
        chart.colors.list = [am4core.color(theme.palette.primary.main)];
        chart.numberFormatter.numberFormat = "'$'#,## | '-$'#,##s";
        chart.dateFormatter.dateFormat = 'yyyy-MM-dd';
        chart.dateFormatter.inputDateFormat = 'yyyy-MM-dd';
        const dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.renderer.grid.template.location = 0.5;
        dateAxis.renderer.ticks.template.disabled = true;
        dateAxis.renderer.line.opacity = 0;
        dateAxis.renderer.grid.template.disabled = true;
        dateAxis.renderer.minGridDistance = 60;
        dateAxis.renderer.labels.template.fontSize = 12;
        dateAxis.renderer.labels.template.fill = am4core.color(theme.palette.others.lightText);
        // @ts-expect-error: Type '400' is not assignable to type 'FontWeight'.
        dateAxis.renderer.labels.template.fontWeight = 400;
        dateAxis.dataFields.date = 'chartDate';
        dateAxis.tooltip.disabled = true;
        dateAxis.dateFormats.setKey('day', 'MMM d');
        dateAxis.periodChangeDateFormats.setKey('day', 'MMM d');
        dateAxisRef.current = dateAxis;
        const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.tooltip.disabled = true;
        valueAxis.renderer.line.opacity = 0;
        valueAxis.renderer.ticks.template.disabled = true;
        valueAxis.renderer.labels.template.fontSize = 12;
        valueAxis.renderer.labels.template.fill = am4core.color(theme.palette.others.lightText);
        // @ts-expect-error: Type '400' is not assignable to type 'FontWeight'.
        valueAxis.renderer.labels.template.fontWeight = 400;
        // valueAxis.extraMax = 0.2;
        valueAxisRef.current = valueAxis;
        dateAxis.renderer.grid.template.disabled = true;
        valueAxis.renderer.grid.template.disabled = true;
        chartRef.current = chart;
        createSeriesFromData(chart);
        chartRef.current.sequencedInterpolation = false;
        // cursor effects
        chart.cursor = new am4charts.XYCursor();
        chart.cursor.behavior = 'none';
        chart.cursor.lineY.disabled = true;
        chart.cursor.lineX.disabled = false;
        chart.cursor.snapToSeries = [...chartRef.current.series];
        chart.zoomOutButton.disabled = true;
        chart.maskBullets = false;
        dateAxisRef.current = dateAxis;
        chartRef.current.events.on('ready', () => {
            zoomGraph(true);
        });
    };
    (0, react_1.useEffect)(() => {
        if (chartData) {
            generateGraph();
        }
        return () => {
            if (chartRef.current) {
                chartRef.current.dispose();
            }
        };
    }, [chartData, theme]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, react_1.useEffect)(() => {
        if (dateRangeRef.current !== dateRange) {
            zoomGraph();
            setActualMin();
            dateRangeRef.current = dateRange;
        }
    }, [dateRange]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, react_1.useEffect)(() => {
        var _a;
        if (accountIdsRef.current !== accountIds && chartRef.current) {
            (_a = accountIdsRef.current) === null || _a === void 0 ? void 0 : _a.forEach((id) => {
                var _a, _b;
                if (!accountIds.includes(id)) {
                    // @ts-expect-error: Argument of type 'number' is not assignable to parameter of type 'string'.
                    (_b = (_a = chartRef.current) === null || _a === void 0 ? void 0 : _a.map.getKey(id)) === null || _b === void 0 ? void 0 : _b.hide();
                }
            });
            accountIdsRef.current = accountIds;
            setActualMin();
        }
    }, [accountIds]); // eslint-disable-line react-hooks/exhaustive-deps
    return (<div className={classes.openRoot} id="projectedBalancesRoot">
      {chartData && (<div id="chart-div-projected-balance" className={(0, classnames_1.default)(classes.chart)}/>)}
      {!chartData && (<div id="chart-div-projected-balance-loading" className={classes.chartLoading}>
          <material_1.Typography variant="h6" className={classes.chartLoadingText}> Loading... </material_1.Typography>
        </div>)}
    </div>);
};
exports.default = AMGraph;
